import { Theme } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

export default function Breadcrumbs(theme: Theme, containerId: string) {
  return {
    MuiBreadcrumbs: {
      defaultProps: {
        container: document.getElementById(containerId),
      },
      styleOverrides: {
        separator: {
          marginLeft: theme.spacing(2),
          marginRight: theme.spacing(2),
          [theme.breakpoints.down('md')]: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
          },
        },
      },
    },
  };
}
